<ng-template appTopbarActions>
  <button mat-mini-fab color="accent" (click)="toggleDemandesOptions()" matTooltip="Options d'affichage">
    <mat-icon>settings</mat-icon>
  </button>
</ng-template>

<mat-drawer-container>

  <mat-drawer-content>

    <div id="demande-conteneur" class="thin-scrollbar" *ngIf="demandesContrat; else loader">
      <div class="fx-direction-col">
        <mat-card appearance="raised" class="card" *ngFor="let demande of demandesFiltered">
          <mat-card-header class="card-header fx-direction-row fx-between-center">
            <mat-card-title class="fx-direction-row fx-start-center"
              [ngStyle]="{'font-size': (platformService.isMobile$ | async) ? '16px' : '20px'}">
              <mat-icon color="primary" style="margin-right: 10px;">description</mat-icon>
              <span>Demande du {{demande.dateDemande | date:"shortDate"}}</span>
            </mat-card-title>
            <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-card-header>

          <mat-menu class="mat-menu-child" #menu="matMenu" xPosition="before">
            <button *ngFor="let formStep of formStepDemandeContratAccueil" mat-menu-item
              (click)="openForm(demande, formStep.stepName)">
              <mat-icon color="primary">{{ (readOnly || isDecided(demande.decision)) ? 'visibility' : 'edit'
                }}</mat-icon>
              {{ formStep.label }}
            </button>
          </mat-menu>

          <mat-card-content style="padding: 8px;">
            <app-status-bar [decision]="demande.decision" [motifRefus]="demande.motifRefus"
              [motifAbandon]="demande.motifAbandon" />

            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Enfant</span>
                <span class="info-value">{{demande.nom}} {{demande.prenom}}</span>
              </div>

              @if(demande.dateSouhaitDebutAccueil) {
              <div class="info-item">
                <span class="info-label">Début d'accueil souhaité</span>
                <span class="info-value">{{demande.dateSouhaitDebutAccueil | date:"shortDate"}}</span>
              </div>
              }

              @if(demande.etablissement) {
              <div class="info-item">
                <span class="info-label">Etablissement</span>
                <span class="info-value">{{demande.etablissement}}</span>
              </div>
              }

              @if(demande.accueil) {
              <div class="info-item">
                <span class="info-label">Accueil</span>
                <span class="info-value">{{demande.accueil}}</span>
              </div>
              }

              @if(demande?.programmation?.length){
              <div class="info-item full-width">
                <span class="info-label">Jours/horaires</span>
                <div class="horaires-grid">
                  @for (entry of demande.programmation; track entry[0]) {
                  @let key = entry[0];
                  @let semaine = entry[1];
                  <div class="semaine-block">
                    <div class="semaine-titre" *ngIf="demande.programmation.length > 1">{{ key }}</div>
                    <div class="jours-list">
                      @for (jour of semaine; track jour) {
                      <div class="jour-item">
                        <span class="jour-nom">{{jour.jour | titlecase}}</span>
                        <div class="horaires-list">
                          @if(jour.plage1Deb){
                          <span class="plage-horaire">{{jour.plage1Deb.substring(0, 5)}} - {{jour.plage1Fin.substring(0,
                            5)}}</span>
                          }
                          @if(jour.plage2Deb){
                          <span class="plage-horaire">{{jour.plage2Deb.substring(0, 5)}} - {{jour.plage2Fin.substring(0,
                            5)}}</span>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
            </div>

          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" *ngIf="permToCreate" class="card card-add">
          <mat-card-header class="fx-direction-row fx-center-center">
            <mat-card-title class="fx-direction-row fx-center-center">
              Nouvelle demande de contrat d'accueil
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="fx-direction-row fx-center-center" style="padding-top: 16px;">
            <button mat-fab color="primary" matTooltip="Nouvelle demande de contrat d'accueil"
              routerLink="/account/demande-contrat-accueil/add">
              <mat-icon>add</mat-icon>
            </button>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="!demandesContrat.length && readOnly">
        <h2 style="text-align: center;">Vous n'avez pas de demande(s) de contrat d'accueil.</h2>
      </div>
    </div>

  </mat-drawer-content>

  <mat-drawer id="previewDrawer" class="mat-elevation-z4 thin-scrollbar" position="end" [(opened)]="drawerOpened">
    <mat-toolbar class="preview-header fx-direction-row fx-between-center" color='primary'>
      <button mat-icon-button (click)="closeDrawer()">
        <mat-icon>close</mat-icon>
      </button>
      <span>Options d'affichage</span>
      <span></span>
    </mat-toolbar>

    <div class="fx-direction-col" style="margin: 5px; padding: 5px;">
      <mat-slide-toggle style="padding-left: 5px;" [(ngModel)]="showDecidedDemandes"
        (ngModelChange)="toggleShowDecidedDemandes($event)" class="slideToggle">
        <span>Afficher les demandes traitées.</span>
      </mat-slide-toggle>
    </div>
  </mat-drawer>

</mat-drawer-container>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>
